<template>
  <ModalMobileDefault modal_id="infoContactModal"
                      header="y"
                      size="modal-xl modal-dialog-scrollable"
                      style_header=""
                      :modal_header="getTranslations('expression_713')"
                      footer="y"
                      class_body="px-0 pt-0"
                      icon="bx bx-info-circle mr-1">
    <div class="px-0 pt-1 pb-3" slot="body">
      <div class="col-12 px-0">
        <TabInfoContact/>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 col-12 d-flex" style="justify-content: center;">
      <div class="pr-2">
            <span data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#transferTicketModal"
                  class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
              <i class="bx bx-transfer-alt"></i>
            </span>
      </div>
      <div class="pr-2">
            <span data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#historyTicketModal"
                  class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
              <i class="bx bx-history"></i>
            </span>
      </div>
      <div class="pr-2">
            <span data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#smsModal"
                  class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
              <i class="bx bx-message-alt-detail"></i>
            </span>
      </div>
      <div class="">
            <span data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#endTicketModal"
                  class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
              <i class="bx bx-x-circle"></i>
            </span>
      </div>
    </div>
  </ModalMobileDefault>
</template>

<script>
import ModalMobileDefault from "../../components/general/ModalMobileDefault";
import TabInfoContact from "../../components/chat/TabInfoContact";
import {mapGetters} from "vuex";

export default {
  name: "ModalChatMobileInfoLead",
  components: {
    ModalMobileDefault,
    TabInfoContact
  },
  computed: {
    ...mapGetters([])
  }
}
</script>

<style scoped>

</style>
